


























import ActivityService from '@/domain/schedule/activitie/activity.service';
import AuditHomeTime from '@/domain/schedule/activitie/audit-home-time.entity';
import Reason from '@/domain/schedule/activitie/reason.entity';
import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AuditActionButtons extends Vue {
  @Prop({
    type: AuditHomeTime,
    required: true,
  }) activity!: AuditHomeTime;

  get showActionButtons(): boolean {
    return this.activity.files.length > 0;
  }

  loadingApprove: boolean = false;

  loadingReject: boolean = false;

  async approve() {
    try {
      this.loadingApprove = true;
      await ActivityService.approveActivity(
        this.activity.activityId,
        new Reason(this.activity.observation),
      );
      VbSnackbarService.showSuccess('Atividade aprovada com sucesso');
      this.$emit('approved');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loadingApprove = false;
    }
  }

  async reject() {
    try {
      this.loadingReject = true;
      await ActivityService.rejectActivity(
        this.activity.activityId,
        new Reason(this.activity.observation),
      );
      VbSnackbarService.showSuccess('Atividade recusada com sucesso');
      this.$emit('rejected');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loadingReject = false;
    }
  }
}
